module.exports = __webpack_public_path__ + "static/media/default_LoginSideImage.2676e271.webp";